import axios from 'axios'
import { CADASTRAR_CIDADE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarRota (cidade) {
  const url = `${URL}/cidades/criar`;
  return dispatch => axios.post(url, cidade, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_CIDADE,
        payload: response
      })
  );
}
